import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Row, Col} from 'react-bootstrap';
import {FormattedMessage} from 'react-intl';
import dateHelper from '../../../helpers/dateHelper';

class StructureAbout extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    let {lang, structure} = this.props;
    return (
      <div>

        <Row>
          <Col sm={3}>
            <strong><FormattedMessage id="dateAnnounced"/></strong>
          </Col>
          <Col sm={9}>
            {dateHelper.formatDate(structure.item.attributes.date_announced, lang)}
          </Col>
        </Row>

        <Row>
          <Col sm={3}>
            <strong><FormattedMessage id="dateConfirmed"/></strong>
          </Col>
          <Col sm={9}>
            {dateHelper.formatDate(structure.item.attributes.date_confirmed, lang)}
          </Col>
        </Row>

        <Row>
          <Col sm={3}>
            <strong><FormattedMessage id="dateEffective"/></strong>
          </Col>
          <Col sm={9}>
            {dateHelper.formatDate(structure.item.attributes.date_effective, lang)}
          </Col>
        </Row>

        <Row>
          <Col sm={3}>
            <strong><FormattedMessage id="dateVersion"/></strong>
          </Col>
          <Col sm={9}>
            {dateHelper.formatDate(structure.item.attributes.date_version, lang)}
          </Col>
        </Row>

        <Row>
          &nbsp;
        </Row>

        {this.props.structure.item.attributes.author && (<Row>
          <Col sm={3}>
            <strong><FormattedMessage id="author"/></strong>
          </Col>
          <Col sm={9}>
            {structure.item.attributes.author || "onbekend"}
          </Col>
        </Row>)}
      </div>
    );
  }
}

StructureAbout.propTypes = {
  structure: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired
};

function mapStateToProps(state, ownProps) {
  const {structure} = state;
  const {lang} = ownProps.params;
  return {
    structure,
    lang
  };
}

export default connect(mapStateToProps)(StructureAbout);



/** WEBPACK FOOTER **
 ** ./src/modules/structures/components/StructureAbout.js
 **/